import { apiGet, apiPost } from './http'
import { normalizeBuildingQuery } from './helpers'

export const list = async (params = {}) =>
  apiGet('/accounting/closures', {
    auth: true,
    config: { params: normalizeBuildingQuery(params) },
    fallbackMessage: 'Error al obtener los cierres mensuales.',
  })

export const get = async id =>
  apiGet(`/accounting/closures/${id}`, {
    auth: true,
    fallbackMessage: 'Error al obtener el cierre mensual.',
  })

export const preview = async payload =>
  apiPost('/accounting/closures/preview', payload, {
    auth: true,
    fallbackMessage: 'Error al previsualizar el cierre mensual.',
  })

export const generate = async payload =>
  apiPost('/accounting/closures/generate', payload, {
    auth: true,
    fallbackMessage: 'Error al generar el borrador de cierre mensual.',
  })

export const close = async id =>
  apiPost(`/accounting/closures/${id}/close`, {}, {
    auth: true,
    fallbackMessage: 'Error al cerrar el cierre mensual.',
  })

export const generateDocuments = async id =>
  apiPost(`/accounting/closures/${id}/documents`, {}, {
    auth: true,
    fallbackMessage: 'Error al generar documentos del cierre mensual.',
  })

export const sendDocuments = async id =>
  apiPost(`/accounting/closures/${id}/send`, {}, {
    auth: true,
    fallbackMessage: 'Error al enviar documentos del cierre mensual.',
  })
